{
  "azul nublado": "#acc2d9",
  "verde pastel oscuro": "#56ae57",
  "polvo": "#b2996e",
  "lima eléctrica": "#a8ff04",
  "verde fresco": "#69d84f",
  "berenjena clara": "#894585",
  "verde desagradable": "#70b23f",
  "realmente azul claro": "#d4ffff",
  "té": "#65ab7c",
  "púrpura cálido": "#952e8f",
  "marrón amarillento": "#fcfc81",
  "cemento": "#a5a391",
  "verde hierba oscuro": "#388004",
  "verde azulado polvoriento": "#4c9085",
  "pato gris": "#5e9b8a",
  "macarrones con queso": "#efb435",
  "tan rosado": "#d99b82",
  "pícea": "#0a5f38",
  "azul fuerte": "#0c06f7",
  "verde tóxico": "#61de2a",
  "windows azul": "#3778bf",
  "azul azul": "#2242c7",
  "azul con un toque de púrpura": "#533cc6",
  "verde mar brillante": "#05ffa6",
  "verde azulado oscuro": "#1f6357",
  "turquesa profundo": "#017374",
  "verde azuloso": "#0cb577",
  "rosa fuerte": "#ff0789",
  "entre": "#afa88b",
  "aqua profundo": "#08787f",
  "rosa lavanda": "#dd85d7",
  "verde musgo claro": "#a6c875",
  "verde marino claro": "#a7ffb5",
  "amarillo oliva": "#c2b709",
  "cerdo rosa": "#e78ea5",
  "lila profundo": "#966ebd",
  "desierta": "#ccad60",
  "lavanda polvorienta": "#ac86a8",
  "gris púrpura": "#947e94",
  "púrpura": "#983fb2",
  "rosa chicle": "#ff63e9",
  "verde pastel claro": "#b2fba5",
  "verde aburrido": "#63b365",
  "verde kiwi": "#8ee53f",
  "gris claro verde": "#b7e1a1",
  "naranja rosa": "#ff6f52",
  "té verde": "#bdf8a3",
  "marrón muy claro": "#d3b683",
  "cáscara de huevo": "#fffcc4",
  "púrpura berenjena": "#430541",
  "rosa en polvo": "#ffb2d0",
  "gris rojizo": "#997570",
  "lila": "#c48efd",
  "azul tempestuoso": "#507b9c",
  "marrón feo": "#7d7103",
  "crema": "#fffd78",
  "rosa oscuro": "#da467d",
  "marrón profundo": "#410200",
  "beige verdoso": "#c9d179",
  "manilla": "#fffa86",
  "azul apagado": "#5684ae",
  "gris acorazado": "#6b7c85",
  "marrón verdoso": "#6f6c0a",
  "moretón": "#7e4071",
  "verde kelley": "#009337",
  "amarillo apagado": "#d0e429",
  "amarillo soleado": "#fff917",
  "azul": "#1d5dec",
  "verde oscuro": "#054907",
  "verde/amarillo": "#b5ce08",
  "líquenes": "#8fb67b",
  "luz verde claro": "#c8ffb0",
  "oro pálido": "#fdde6c",
  "amarillo sol": "#ffdf22",
  "tan verde": "#a9be70",
  "burple": "#6832e3",
  "dulce de mantequilla": "#fdb147",
  "peluca": "#c7ac7d",
  "crema oscura": "#fff39a",
  "rojo indio": "#850e04",
  "lavanda clara": "#efc0fe",
  "verde venenoso": "#40fd14",
  "verde oliva claro": "#b6c406",
  "amarillo verde brillante": "#9dff00",
  "gris carbón": "#3c4142",
  "calabaza": "#f2ab15",
  "canela": "#ac4f06",
  "verde guisante claro": "#c4fe82",
  "verde radiactivo": "#2cfa1f",
  "siena cruda": "#9a6200",
  "bebé morado": "#ca9bf7",
  "cacao": "#875f42",
  "azul real claro": "#3a2efe",
  "naranja": "#fd8d49",
  "marrón óxido": "#8b3103",
  "marrón arena": "#cba560",
  "pantano": "#698339",
  "verde azulado": "#0cdc73",
  "siena quemada": "#b75203",
  "camuflaje": "#7f8f4e",
  "azul crepúsculo": "#26538d",
  "helecho": "#63a950",
  "vieja rosa": "#c87f89",
  "luz verde pálido": "#b1fc99",
  "rosa melocotón": "#ff9a8a",
  "rosa brillante": "#f6688e",
  "verde azulino claro": "#76fda8",
  "luz verde brillante": "#53fe5c",
  "verde neón claro": "#4efd54",
  "espuma de mar clara": "#a0febf",
  "azul Tiffany": "#7bf2da",
  "verde deslavado": "#bcf5a6",
  "marrón anaranjado": "#ca6b02",
  "bonito azul": "#107ab0",
  "zafiro": "#2138ab",
  "turquesa grisáceo": "#719f91",
  "amarillo anaranjado": "#fdb915",
  "pergamino": "#fefcaf",
  "paja": "#fcf679",
  "marrón muy oscuro": "#1d0200",
  "terracota": "#cb6843",
  "feo azul": "#31668a",
  "claro azul": "#247afd",
  "crema": "#ffffb6",
  "verde espuma": "#90fda9",
  "gris/verde": "#86a17d",
  "oro claro": "#fddc5c",
  "azul espumoso": "#78d1b6",
  "topacio": "#13bbaf",
  "rosa violeta": "#fb5ffc",
  "menta de invierno": "#20f986",
  "bronceado amarillo": "#ffe36e",
  "fucsia oscuro": "#9d0759",
  "azul índigo": "#3a18b1",
  "verde amarillento claro": "#c2ff89",
  "magenta pálido": "#d767ad",
  "púrpura rico": "#720058",
  "amarillo girasol": "#ffda03",
  "verde/azul": "#01c08d",
  "cuero": "#ac7434",
  "verde de carreras": "#014600",
  "púrpura vívido": "#9900fa",
  "azul real oscuro": "#02066f",
  "avellana": "#8e7618",
  "rosa apagado": "#d1768f",
  "canaria": "#fdff63",
  "gris fresco": "#95a3a6",
  "taupe oscuro": "#7f684e",
  "púrpura oscura": "#751973",
  "verde verdadero": "#089404",
  "rosa coral": "#ff6163",
  "sabio oscuro": "#598556",
  "azul pizarra oscuro": "#214761",
  "azul plano": "#3c73a8",
  "hongo": "#ba9e88",
  "azul rico": "#021bf9",
  "púrpura sucio": "#734a65",
  "verdeazul": "#23c48b",
  "verde asqueroso": "#8fae22",
  "caqui claro": "#e6f2a2",
  "azul cálido": "#4b57db",
  "rosa oscuro caliente": "#d90166",
  "azul marino profundo": "#015482",
  "carmesí": "#9d0216",
  "verde amarillento oscuro": "#728f02",
  "durazno pálido": "#ffe5ad",
  "morado ciruela": "#4e0550",
  "vara de oro": "#f9bc08",
  "rojo neón": "#ff073a",
  "viejo rosa": "#c77986",
  "azul muy pálido": "#d6fffe",
  "naranja sanguina": "#fe4b03",
  "pomelo": "#fd5956",
  "amarillo arena": "#fce166",
  "marrón arcilla": "#b2713d",
  "gris azul oscuro": "#1f3b4d",
  "verde plano": "#699d4c",
  "verde azulado claro": "#56fca2",
  "rosa cálido": "#fb5581",
  "azul dodger": "#3e82fc",
  "verde grosero": "#a0bf16",
  "hielo": "#d6fffa",
  "azul metálico": "#4f738e",
  "salmón pálido": "#ffb19a",
  "verde sap": "#5c8b15",
  "algas": "#54ac68",
  "gris azulado": "#89a0b0",
  "gris verdoso": "#7ea07a",
  "resaltador verde": "#1bfc06",
  "luz azul claro": "#cafffb",
  "menta clara": "#b6ffbb",
  "siena quemada": "#a75e09",
  "azul vívido": "#152eff",
  "lavanda profunda": "#8d5eb7",
  "turquesa apagado": "#5f9e8f",
  "verdeazulado claro": "#63f7b4",
  "verde barro": "#606602",
  "pinky": "#fc86aa",
  "vino tinto": "#8c0034",
  "marrón bronceado": "#ab7e4c",
  "azul oscuro": "#030764",
  "rosa": "#fe86a4",
  "barra de labios": "#d5174e",
  "mauve pálido": "#fed0fc",
  "claret": "#680018",
  "diente de león": "#fedf08",
  "naranja rojo": "#fe420f",
  "rubí": "#ca0147",
  "oscura": "#1b2431",
  "turquesa verdoso": "#00fbb0",
  "pastel rojo": "#db5856",
  "cian brillante": "#41fdfe",
  "coral oscuro": "#cf524e",
  "alga verde": "#21c36f",
  "rojo oscuro": "#a90308",
  "reddy marrón": "#6e1005",
  "rosa rubor": "#fe828c",
  "verde camuflaje": "#4b6113",
  "verde césped": "#4da409",
  "putty": "#beae8a",
  "azul vibrante": "#0339f8",
  "arena oscura": "#a88f59",
  "púrpura/azul": "#5d21d0",
  "azafrán": "#feb209",
  "crepúsculo": "#4e518b",
  "marrón cálido": "#964e02",
  "grisazul": "#85a3b2",
  "rosa chicle": "#ff69af",
  "huevo de pato azul": "#c3fbf4",
  "cian verdoso": "#2afeb7",
  "petróleo": "#005f6a",
  "real": "#0c1793",
  "mantequilla": "#ffff81",
  "naranja polvoriento": "#f0833a",
  "amarillo apagado": "#f1f33f",
  "verde oliva pálido": "#b1d27b",
  "naranja": "#fc824a",
  "hoja": "#71aa34",
  "gris azul claro": "#b7c9e2",
  "rojo profundo": "#4b0101",
  "púrpura claro": "#a552e6",
  "rojo oxidado": "#af2f0d",
  "lavanda azul": "#8b88f8",
  "verde hierba claro": "#9af764",
  "verde menta claro": "#a6fbb2",
  "girasol": "#ffc512",
  "terciopelo": "#750851",
  "naranja ladrillo": "#c14a09",
  "rojo claro": "#fe2f4a",
  "azul puro": "#0203e2",
  "azul crepúsculo": "#0a437a",
  "rojo violeta": "#a50055",
  "marrón amarillento": "#ae8b0c",
  "clavel": "#fd798f",
  "amarillo fangoso": "#bfac05",
  "verde mar oscuro": "#3eaf76",
  "rosa profundo": "#c74767",
  "rojo polvoriento": "#b9484e",
  "gris/azul": "#647d8e",
  "lima limón": "#bffe28",
  "morado/rosa": "#d725de",
  "marrón amarillo": "#b29705",
  "marrón púrpura": "#673a3f",
  "glicinia": "#a87dc2",
  "plátano amarillo": "#fafe4b",
  "rojo labial": "#c0022f",
  "agua azul": "#0e87cc",
  "marrón gris": "#8d8468",
  "púrpura vibrante": "#ad03de",
  "bebé verde": "#8cff9e",
  "verde apagado": "#94ac02",
  "azul cáscara de huevo": "#c4fff7",
  "amarillo arenoso": "#fdee73",
  "verde fresco": "#33b864",
  "pálida": "#fff9d0",
  "azul/gris": "#758da3",
  "magenta caliente": "#f504c9",
  "grisazul": "#77a1b5",
  "púrpura": "#8756e4",
  "rosado marrón": "#c27e79",
  "aguamarina oscura": "#017371",
  "diarrea": "#9f8303",
  "mostaza clara": "#f7d560",
  "azul pálido": "#bdf6fe",
  "tortuga verde": "#75b84f",
  "oliva brillante": "#9cbb04",
  "gris oscuro azul": "#29465b",
  "marrón verdoso": "#696006",
  "limón verde": "#adf802",
  "lila claro": "#c1c6fc",
  "verde algas": "#35ad6b",
  "amarillo sol": "#fffd37",
  "feo púrpura": "#a442a0",
  "rosa medio": "#f36196",
  "marrón cálido": "#947706",
  "rosa muy claro": "#fff4f2",
  "viridiano": "#1e9167",
  "amarillo desvanecido": "#feff7f",
  "verde muy pálido": "#cffdbc",
  "verde vibrante": "#0add08",
  "lima brillante": "#87fd05",
  "hierbabuena": "#1ef876",
  "agua marina claro": "#7bfdc7",
  "salvia ligera": "#bcecac",
  "verdeamarillo": "#bbf90f",
  "bronce profundo": "#ab9004",
  "espuma de mar oscura": "#1fb57a",
  "verde azul profundo": "#00555a",
  "brezo": "#a484ac",
  "naranja óxido": "#c45508",
  "azul sucio": "#3f829d",
  "verde fern": "#548d44",
  "lila brillante": "#c95efb",
  "verde brillante": "#3ae57f",
  "azul pavo real": "#016795",
  "verde aguacate": "#87a922",
  "naranja desvanecido": "#f0944d",
  "uva morada": "#5d1451",
  "verde caliente": "#25ff29",
  "amarillo lima": "#d0fe1d",
  "mango": "#ffa62b",
  "trébol": "#01b44c",
  "chicle": "#ff6cb5",
  "marrón purpúreo": "#6b4247",
  "cian pálido": "#b7fffa",
  "lima clave": "#aeff6e",
  "rojo tomate": "#ec2d01",
  "verde claro": "#76ff7b",
  "merlot": "#730039",
  "azul noche": "#040348",
  "rosado púrpura": "#df4ec8",
  "manzana": "#6ecb3c",
  "manzana verde": "#5edc1f",
  "heliotropo": "#d94ff5",
  "amarillo/verde": "#c8fd3d",
  "casi negro": "#070d0d",
  "azul fresco": "#4984b8",
  "verdura de hoja verde": "#51b73b",
  "marrón mostaza": "#ac7e04",
  "crepúsculo": "#4e5481",
  "marrón apagado": "#876e4b",
  "verde rana": "#58bc08",
  "verde vívido": "#2fef10",
  "luz verde brillante": "#2dfe54",
  "verde flúor": "#0aff02",
  "kiwi": "#9cef43",
  "alga": "#18d17b",
  "verde marino": "#35530a",
  "azul ultramar": "#1805db",
  "iris": "#6258c4",
  "pastel naranja": "#ff964f",
  "naranja amarillento": "#ffab0f",
  "periwinkle": "#8f8ce7",
  "tealish": "#24bca8",
  "ciruela oscura": "#3f012c",
  "pera": "#cbf85f",
  "naranja rosado": "#ff724c",
  "púrpura medianoche": "#280137",
  "luz púrpura": "#b36ff6",
  "menta oscura": "#48c072",
  "marrón verdoso": "#bccb7a",
  "burdeos claro": "#a8415b",
  "turquesa": "#06b1c4",
  "rosa feo": "#cd7584",
  "arenoso": "#f1da7a",
  "rosa eléctrico": "#ff0490",
  "púrpura apagado": "#805b87",
  "verde medio": "#50a747",
  "grisáceo": "#a8a495",
  "amarillo neón": "#cfff04",
  "banana": "#ffff7e",
  "rosa clavel": "#ff7fa7",
  "tomate": "#ef4026",
  "mar": "#3c9992",
  "marrón barro": "#886806",
  "verde turquesa": "#04f489",
  "bufar": "#fef69e",
  "cierva": "#cfaf7b",
  "azul apagado": "#3b719f",
  "rosa pálido": "#fdc1c5",
  "verde menta oscuro": "#20c073",
  "amatista": "#9b5fc0",
  "azul/verde": "#0f9b8e",
  "castaña": "#742802",
  "verde apagado": "#9db92c",
  "guisante": "#a4bf20",
  "naranja oxidado": "#cd5909",
  "piedra": "#ada587",
  "roja rosa": "#be013c",
  "aqua pálido": "#b8ffeb",
  "naranja intenso": "#dc4d01",
  "tierra": "#a2653e",
  "verde musgoso": "#638b27",
  "verde gramado": "#419c03",
  "verde lima pálido": "#b1ff65",
  "azul gris claro": "#9dbcd4",
  "gris pálido": "#fdfdfe",
  "espárrago": "#77ab56",
  "arándano": "#464196",
  "rojo púrpura": "#990147",
  "lima pálida": "#befd73",
  "turquesa verdoso": "#32bf84",
  "caramelo": "#af6f09",
  "magenta profundo": "#a0025c",
  "melocotón claro": "#ffd8b1",
  "chocolate con leche": "#7f4e1e",
  "ocre": "#bf9b0c",
  "verde apagado": "#6ba353",
  "rosa púrpura": "#f075e6",
  "azul claro": "#7bc8f6",
  "azul grisáceo": "#475f94",
  "dorada": "#f5bf03",
  "beige claro": "#fffeb6",
  "amarillo mantequilla": "#fffd74",
  "púrpura oscuro": "#895b7b",
  "azul francés": "#436bad",
  "amarillo feo": "#d0c101",
  "verde amarillento": "#c6f808",
  "rojo anaranjado": "#f43605",
  "verde trébol": "#02c14d",
  "marrón anaranjado": "#b25f03",
  "árbol verde": "#2a7e19",
  "violeta profundo": "#490648",
  "acero": "#536267",
  "azul/morado": "#5a06ef",
  "cereza": "#cf0234",
  "marrón arenoso": "#c4a661",
  "gris cálido": "#978a84",
  "índigo oscuro": "#1f0954",
  "medianoche": "#03012d",
  "verde azulado": "#2bb179",
  "gris rosa": "#c3909b",
  "púrpura suave": "#a66fb5",
  "rojo oscuro": "#770001",
  "marrón rojo": "#922b05",
  "gris medio": "#7d7f7c",
  "baya": "#990f4b",
  "marrón": "#8f7303",
  "rosado púrpura": "#c83cb9",
  "salmón claro": "#fea993",
  "púrpura de Pascua": "#c071fe",
  "amarillo claro verde": "#ccfd7f",
  "azul marino oscuro": "#00022e",
  "muerte": "#828344",
  "rosa claro": "#ffc5cb",
  "rojo": "#ab1239",
  "rojo purpúreo": "#b0054b",
  "verde slime": "#99cc04",
  "verde irlandés": "#019529",
  "rosa/púrpura": "#ef1de7",
  "azul marino oscuro": "#000435",
  "verde azulado": "#42b395",
  "ciruela clara": "#9d5783",
  "gris rosado": "#c8aca9",
  "naranja sucia": "#c87606",
  "rojo óxido": "#aa2704",
  "lila pálido": "#e4cbff",
  "rojo anaranjado": "#fa4224",
  "azul primario": "#0804f9",
  "kermit verde": "#5cb200",
  "morado marrón": "#76424e",
  "verde turbio": "#6c7a0e",
  "trigo": "#fbdd7e",
  "morado muy oscuro": "#2a0134",
  "verde botella": "#044a05",
  "sandía": "#fd4659",
  "azul cielo profundo": "#0d75f8",
  "rojo fuego": "#fe0002",
  "ocre amarillo": "#cb9d06",
  "naranja calabaza": "#fb7d07",
  "aceituna pálida": "#b9cc81",
  "lila claro": "#edc8ff",
  "verde claro": "#61e160",
  "azul carolina": "#8ab8fe",
  "mora": "#920a4e",
  "rosa impactante": "#fe02a2",
  "castaño": "#9a3001",
  "verde lima brillante": "#65fe08",
  "celadón": "#befdb7",
  "marrón rosado": "#b17261",
  "marrón profundo": "#885f01",
  "azul cielo brillante": "#02ccfe",
  "apio": "#c1fd95",
  "marrón sucio": "#836539",
  "fresa": "#fb2943",
  "lima oscura": "#84b701",
  "cobre": "#b66325",
  "marrón medio": "#7f5112",
  "verde apagado": "#5fa052",
  "huevo de petirrojo": "#6dedfd",
  "aqua brillante": "#0bf9ea",
  "lavanda brillante": "#c760ff",
  "marfil": "#ffffcb",
  "morado muy claro": "#f6cefc",
  "azul marino claro": "#155084",
  "rojo rosa": "#f5054f",
  "marrón oliva": "#645403",
  "mostaza verde": "#a8b504",
  "verde océano": "#3d9973",
  "azul muy oscuro": "#000133",
  "verde polvoriento": "#76a973",
  "azul marino claro": "#2e5a88",
  "verde menta": "#0bf77d",
  "adobe": "#bd6c48",
  "barney": "#ac1db8",
  "verde jade": "#2baf6a",
  "luz azul brillante": "#26f7fd",
  "lima ligera": "#aefd6c",
  "caqui oscuro": "#9b8f55",
  "naranja amarillo": "#ffad01",
  "ocre": "#c69c04",
  "maíz": "#f4d054",
  "rosa desvanecido": "#de9dac",
  "verde de carreras británico": "#05480d",
  "arenisca": "#c9ae74",
  "marrón barro": "#60460f",
  "verde mar claro": "#98f6b0",
  "azul huevo de petirrojo": "#8af1fe",
  "turquesa": "#2ee8bb",
  "verde mar oscuro": "#11875d",
  "rosa suave": "#fdb0c0",
  "marrón anaranjado": "#b16002",
  "rojo cereza": "#f7022a",
  "amarillo quemado": "#d5ab09",
  "gris marrón": "#86775f",
  "camel": "#c69f59",
  "gris púrpura": "#7a687f",
  "marina": "#042e60",
  "rosado grisáceo": "#c88d94",
  "turquesa pálido": "#a5fbd5",
  "amarillo pastel": "#fffe71",
  "azul morado": "#6241c7",
  "amarillo canario": "#fffe40",
  "rojo desvanecido": "#d3494e",
  "sepia": "#985e2b",
  "café": "#a6814c",
  "magenta brillante": "#ff08e8",
  "mocha": "#9d7651",
  "beige": "#feffca",
  "púrpura": "#98568d",
  "arándano": "#9e003a",
  "verde oscuro": "#287c37",
  "naranja marrón": "#b96902",
  "rosa tenebroso": "#ba6873",
  "melón": "#ff7855",
  "verde apagado": "#94b21c",
  "plata": "#c5c9c7",
  "azul púrpura": "#661aee",
  "azul púrpura": "#6140ef",
  "verde hospital": "#9be5aa",
  "azul medio": "#276ab3",
  "ámbar": "#feb308",
  "verde de Pascua": "#8cfd7e",
  "azul suave": "#6488ea",
  "azul ceruleo": "#056eee",
  "marrón dorado": "#b27a01",
  "turquesa brillante": "#0ffef9",
  "rojo rosa": "#fa2a55",
  "rojo púrpura": "#820747",
  "marrón grisáceo": "#7a6a4f",
  "bermellón": "#f4320c",
  "russet": "#a13905",
  "gris acero": "#6f828a",
  "púrpura más claro": "#a55af4",
  "violeta brillante": "#ad0afd",
  "azul prusiano": "#004577",
  "verde pizarra": "#658d6d",
  "Rosa sucio": "#ca7b80",
  "verde azulado oscuro": "#005249",
  "pino": "#2b5d34",
  "verde amarillento": "#bff128",
  "oro oscuro": "#b59410",
  "azulado": "#2976bb",
  "azul oscuro": "#014182",
  "rojo apagado": "#bb3f3f",
  "rojo rosado": "#fc2647",
  "bronce": "#a87900",
  "turquesa pálido": "#82cbb2",
  "verde militar": "#667c3e",
  "rosa de Barbie": "#fe46a5",
  "rosa chicle": "#fe83cc",
  "sopa de guisantes verde": "#94a617",
  "mostaza oscura": "#a88905",
  "púrpura medio": "#9e43a2",
  "verde muy oscuro": "#062e03",
  "suciedad": "#8a6e45",
  "rosa oscuro": "#cc7a8b",
  "violeta rojo": "#9e0168",
  "amarillo limón": "#fdff38",
  "pistache": "#c0fa8b",
  "amarillo apagado": "#eedc5b",
  "verde lima oscuro": "#7ebd01",
  "azul vaquero": "#3b5b92",
  "azul verde": "#01889f",
  "azul claro": "#3d7afd",
  "azul morado": "#5f34e7",
  "indigo claro": "#6d5acf",
  "verde pantano": "#748500",
  "marrón verde": "#706c11",
  "marrón oscuro": "#3c0008",
  "púrpura caliente": "#cb00f5",
  "verde bosque oscuro": "#002d04",
  "azul desvanecido": "#658cbb",
  "verde apagado": "#749551",
  "lima verde claro": "#b9ff66",
  "verde oliva apagado": "#9dc100",
  "amarillenta": "#faee66",
  "verde azul claro": "#7efbb3",
  "Burdeos": "#7b002c",
  "lila claro": "#c292a1",
  "océano": "#017b92",
  "caléndula": "#fcc006",
  "verde lodoso": "#657432",
  "naranja apagado": "#d8863b",
  "acero": "#738595",
  "púrpura eléctrico": "#aa23ff",
  "verde fluorescente": "#08ff08",
  "marrón amarillento": "#9b7a01",
  "sonrojarse": "#f29e8e",
  "verde suave": "#6fc276",
  "naranja brillante": "#ff5b00",
  "limón": "#fdff52",
  "gris púrpura": "#866f85",
  "verde ácido": "#8ffe09",
  "lavanda pálida": "#eecffe",
  "azul violeta": "#510ac9",
  "verde claro bosque": "#4f9153",
  "rojo quemado": "#9f2305",
  "verde caqui": "#728639",
  "cerise": "#de0c62",
  "púrpura desvanecido": "#916e99",
  "albaricoque": "#ffb16d",
  "verde oliva oscuro": "#3c4d03",
  "marrón grisáceo": "#7f7053",
  "gris verdoso": "#77926f",
  "azul verdadero": "#010fcc",
  "violeta pálido": "#ceaefa",
  "azul plisado": "#8f99fb",
  "azul cielo claro": "#c6fcff",
  "azul violáceo": "#5539cc",
  "marrón verde": "#544e03",
  "azulverde": "#017a79",
  "verde azul brillante": "#01f9c6",
  "amarillo marrón": "#c9b003",
  "sopa de guisantes": "#929901",
  "bosque": "#0b5509",
  "barney morado": "#a00498",
  "ultramarino": "#2000b1",
  "purpúreo": "#94568c",
  "latón desvanecido": "#c2be0e",
  "gris azulado": "#748b97",
  "morado oscuro": "#665fd1",
  "lila oscuro": "#9c6da5",
  "rojizo": "#c44240",
  "marrón claro": "#a24857",
  "púrpura polvoriento": "#825f87",
  "terracota": "#c9643b",
  "aguacate": "#90b134",
  "azul marino": "#01386a",
  "verde azulado": "#25a36f",
  "gris pizarra": "#59656d",
  "verde más claro": "#75fd63",
  "verde eléctrico": "#21fc0d",
  "azul polvoriento": "#5a86ad",
  "amarillo dorado": "#fec615",
  "amarillo brillante": "#fffd01",
  "lavanda clara": "#dfc5fe",
  "número": "#b26400",
  "marrón medio": "#7f5e00",
  "durazno oscuro": "#de7e5d",
  "verde jungla": "#048243",
  "cáscara de huevo": "#ffffd4",
  "denim": "#3b638c",
  "marrón amarillo": "#b79400",
  "púrpura apagado": "#84597e",
  "marrón chocolate": "#411900",
  "rojo vino": "#7b0323",
  "azul neón": "#04d9ff",
  "verde sucio": "#667e2c",
  "bronce claro": "#fbeeac",
  "azul hielo": "#d7fffe",
  "azul cadete": "#4e7496",
  "mauve oscuro": "#874c62",
  "azul muy claro": "#d5ffff",
  "gris púrpura": "#826d8c",
  "rosa pastel": "#ffbacd",
  "verde muy claro": "#d1ffbd",
  "azul cielo oscuro": "#448ee4",
  "siempre verde": "#05472a",
  "rosa apagado": "#d5869d",
  "berenjena": "#3d0734",
  "caoba": "#4a0100",
  "naranja rojizo": "#f8481c",
  "verde profundo": "#02590f",
  "púrpura rosa": "#e03fd8",
  "rosa empolvado": "#d58a94",
  "verde desvanecido": "#7bb274",
  "verde camuflaje": "#526525",
  "rosa púrpura": "#c94cbe",
  "rosa púrpura": "#db4bda",
  "rojo marrón": "#9e3623",
  "rosa oscura": "#b5485d",
  "barro": "#735c12",
  "marrón": "#9c6d57",
  "verde esmeralda": "#028f1e",
  "marrón pálido": "#b1916e",
  "azul apagado": "#49759c",
  "siena tostada": "#a0450e",
  "verde medio": "#39ad48",
  "arcilla": "#b66a50",
  "aqua claro": "#8cffdb",
  "verde oliva claro": "#a4be5c",
  "naranja marrón": "#cb7723",
  "aqua oscuro": "#05696b",
  "rosa púrpura": "#ce5dae",
  "salmón oscuro": "#c85a53",
  "gris verdoso": "#96ae8d",
  "jade": "#1fa774",
  "verde feo": "#7a9703",
  "beige oscuro": "#ac9362",
  "esmeralda": "#01a049",
  "rojo pálido": "#d9544d",
  "magenta claro": "#fa5ff7",
  "cielo": "#82cafc",
  "cian claro": "#acfffc",
  "naranja amarilla": "#fcb001",
  "púrpura rojizo": "#910951",
  "rosa rojizo": "#fe2c54",
  "orquídea": "#c875c4",
  "amarillo sucio": "#cdc50a",
  "rojo anaranjado": "#fd411e",
  "rojo profundo": "#9a0200",
  "naranja marrón": "#be6400",
  "azul cobalto": "#030aa7",
  "rosa neón": "#fe019a",
  "rosa pálido": "#f7879a",
  "púrpura grisáceo": "#887191",
  "frambuesa": "#b00149",
  "verde aqua": "#12e193",
  "rosa salmón": "#fe7b7c",
  "mandarina": "#ff9408",
  "verde marrón": "#6a6e09",
  "marrón rojizo": "#8b2e16",
  "marrón verdoso": "#696112",
  "calabaza": "#e17701",
  "verde pino": "#0a481e",
  "carbón": "#343837",
  "rosa bebé": "#ffb7ce",
  "cornflower": "#6a79f7",
  "violeta azul": "#5d06e9",
  "chocolate": "#3d1c02",
  "verde grisáceo": "#82a67d",
  "escarlata": "#be0119",
  "verde amarillo": "#c9ff27",
  "verde oliva oscuro": "#373e02",
  "siena": "#a9561e",
  "púrpura pastel": "#caa0ff",
  "terracota": "#ca6641",
  "azul aqua": "#02d8e9",
  "verde salvia": "#88b378",
  "carmesí": "#980002",
  "rosa profundo": "#cb0162",
  "hierba": "#5cac2d",
  "musgo": "#769958",
  "azul pastel": "#a2bffe",
  "verde azulado": "#10a674",
  "verde azul": "#06b48b",
  "bronceado oscuro": "#af884a",
  "azul verdoso": "#0b8b87",
  "naranja pálido": "#ffa756",
  "verde bosque": "#154406",
  "lavanda oscura": "#856798",
  "violeta oscuro": "#34013f",
  "azul púrpura": "#632de9",
  "cian oscuro": "#0a888a",
  "verde oliva": "#6f7632",
  "rosado": "#d46a7e",
  "cobalto": "#1e488f",
  "púrpura neón": "#bc13fe",
  "turquesa claro": "#7ef4cc",
  "verde manzana": "#76cd26",
  "verde apagado": "#74a662",
  "vino": "#80013f",
  "azul polvo": "#b1d1fc",
  "blanco roto": "#ffffe4",
  "azul eléctrico": "#0652ff",
  "turquesa oscuro": "#045c5a",
  "azul púrpura": "#5729ce",
  "azure": "#069af3",
  "rojo brillante": "#ff000d",
  "rojo rosado": "#f10c45",
  "azul aciano": "#5170d7",
  "verde oliva claro": "#acbf69",
  "uva": "#6c3461",
  "azul grisáceo": "#5e819d",
  "azul purpúreo": "#601ef9",
  "verde amarillento": "#b0dd16",
  "amarillo verdoso": "#cdfd02",
  "azul medio": "#2c6fbb",
  "rosa polvoriento": "#c0737a",
  "violeta claro": "#d6b4fc",
  "azul medianoche": "#020035",
  "púrpura azulado": "#703be7",
  "naranja roja": "#fd3c06",
  "magenta oscuro": "#960056",
  "verdoso": "#40a368",
  "azul océano": "#03719c",
  "coral": "#fc5a50",
  "crema": "#ffffc2",
  "marrón rojizo": "#7f2b0a",
  "siena quemada": "#b04e0f",
  "ladrillo": "#a03623",
  "sabio": "#87ae73",
  "verde grisáceo": "#789b73",
  "blanca": "#ffffff",
  "azul huevo de petirrojo": "#98eff9",
  "verde musgo": "#658b38",
  "azul acero": "#5a7d9a",
  "berenjena": "#380835",
  "amarillo claro": "#fffe7a",
  "verde hoja": "#5ca904",
  "gris claro": "#d8dcd6",
  "oro apagado": "#a5a502",
  "purpura rosado": "#d648d7",
  "azul marino": "#047495",
  "púrpura pálido": "#b790d4",
  "azul pizarra": "#5b7c99",
  "gris azul": "#607c8e",
  "verde cazador": "#0b4008",
  "fucsia": "#ed0dd9",
  "carmesí": "#8c000f",
  "amarillo pálido": "#ffff84",
  "ocre": "#bf9005",
  "amarillo mostaza": "#d2bd0a",
  "rojo claro": "#ff474c",
  "cerúleo": "#0485d1",
  "rosa pálido": "#ffcfdc",
  "azul profundo": "#040273",
  "óxido": "#a83c09",
  "verde agua claro": "#90e4c1",
  "pizarra": "#516572",
  "hierba dorada": "#fac205",
  "amarillo oscuro": "#d5b60a",
  "gris oscuro": "#363737",
  "verde ejército": "#4b5d16",
  "azul grisáceo": "#6b8ba4",
  "espuma de mar": "#80f9ad",
  "pulga": "#a57e52",
  "verde primavera": "#a9f971",
  "naranja oscuro": "#c65102",
  "arena": "#e2ca76",
  "verde pastel": "#b0ff9d",
  "menta": "#9ffeb0",
  "naranja claro": "#fdaa48",
  "rosa brillante": "#fe01b1",
  "chartreuse": "#c1f80a",
  "púrpura profundo": "#36013f",
  "marrón oscuro": "#341c02",
  "topo": "#b9a281",
  "verde guisante": "#8eab12",
  "verde oliva": "#9aae07",
  "verde Kelly": "#02ab2e",
  "verde espuma de mar": "#7af9ab",
  "verde azul": "#137e6d",
  "caqui": "#aaa662",
  "burgundy": "#610023",
  "verde azul oscuro": "#014d4e",
  "rojo ladrillo": "#8f1402",
  "púrpura real": "#4b006e",
  "ciruela": "#580f41",
  "verde menta": "#8fff9f",
  "oro": "#dbb40c",
  "azul bebé": "#a2cffe",
  "verde amarillo": "#c0fb2d",
  "púrpura brillante": "#be03fd",
  "rojo oscuro": "#840000",
  "azul pálido": "#d0fefe",
  "verde hierba": "#3f9b0b",
  "marina": "#01153e",
  "turquesa": "#04d8b2",
  "naranja quemado": "#c04e01",
  "verde neón": "#0cff0c",
  "azul brillante": "#0165fc",
  "rosa": "#cf6275",
  "rosa claro": "#ffd1df",
  "mostaza": "#ceb301",
  "índigo": "#380282",
  "lima": "#aaff32",
  "verde mar": "#53fca1",
  "lila": "#8e82fe",
  "rosa oscuro": "#cb416b",
  "verde oliva": "#677a04",
  "durazno": "#ffb07c",
  "verde pálido": "#c7fdb5",
  "marrón claro": "#ad8150",
  "rosa caliente": "#ff028d",
  "negra": "#000000",
  "lila": "#cea2fd",
  "azul marino": "#001146",
  "azul real": "#0504aa",
  "beige": "#e6daa6",
  "salmón": "#ff796c",
  "aceituna": "#6e750e",
  "marrón": "#650021",
  "verde brillante": "#01ff07",
  "púrpura oscuro": "#35063e",
  "mauve": "#ae7181",
  "verde bosque": "#06470c",
  "aqua": "#13eac9",
  "cian": "#00ffff",
  "tan": "#d1b26f",
  "azul oscuro": "#00035b",
  "lavanda": "#c79fef",
  "turquesa": "#06c2ac",
  "verde oscuro": "#033500",
  "violeta": "#9a0eea",
  "púrpura claro": "#bf77f6",
  "verde lima": "#89fe05",
  "gris": "#929591",
  "azul cielo": "#75bbfd",
  "amarilla": "#ffff14",
  "magenta": "#c20078",
  "verde claro": "#96f97b",
  "naranja": "#f97306",
  "verde azulado": "#029386",
  "azul claro": "#95d0fc",
  "roja": "#e50000",
  "marrón": "#653700",
  "rosa": "#ff81c0",
  "azul": "#0343df",
  "verde": "#15b01a",
  "púrpura": "#7e1e9c"
}
